<template>
    <ConfirmDialog />
    <Toast />
	<div class="grid nested-grid">
		<div class="col-12">
			<div class="card fluid cardheader">
				<div class="col-12">
					<h5 class="stationsHeader">{{ translated('financedtitle') }}</h5>
				</div>												
			</div>
            <DataTable :value="financedRecords" class="p-datatable-sm" removableSort showGridlines dataKey="id" 
            v-model:loading="loading1" responsiveLayout="scroll" :rowHover="true"            
            :paginator="false" :rows="100">
                    <template #header>
                        <div class="flex justify-content-between">
                            <Button :label="translated('financedNew')" :disabled="isReadOnly" icon="pi pi-plus" class="p-button" @click="openModalAddFinanced()"  />	
                        </div>
                    </template>        
                    <template #empty>
                        No financed records found.
                    </template>
                    <template #loading>
                        Loading financed data. Please wait.
                    </template>    
                    
                <Column :header="translated('virgridlabel')" field="FinancedSourceName"></Column>    
                <Column :header="translated('virgridlabelInstrument')" field="FinancedSourceInstrument"></Column>    
                <Column :header="translated('financedName')" field="Name" :sortable="true"></Column>                                                                  
                <Column :header="translated('finacedDescription')">
                    <template #body="slotProps">
                        <div style="white-space: pre-line; word-break: break-word;">
                            {{ slotProps.data.Description }}
                        </div>
                    </template>                
                </Column>
                <Column :header="translated('financedFrom')">
                    <template #body="slot">
                        {{ formatDate(slot.data.FinancedFrom) }}
                    </template>
                </Column>
                <Column :header="translated('financedTo')">
                    <template #body="slot">
                        {{ formatDate(slot.data.FinancedTill) }}
                    </template>                
                </Column>
                <Column :header="translated('financedInserted')">
                    <template #body="slot">
                        {{ formatDate(slot.data.InsertedDate) }}
                    </template>                
                </Column>
                <Column :exportable="false" :style="{width:'100px'}">
                    <template #body="slotProps">
                        <Button :disabled="isReadOnly" icon="pi pi-trash" class="p-button-rounded p-button-warning deletebutton" @click="deleteFinanced(slotProps.data)" />
                        <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2 editbutton" @click="openModalEditFinanced(slotProps.data)" />											
                    </template>
                </Column>	               
            </DataTable>
        </div>  
    </div>  

    <Dialog v-model:visible="displayModalAddFinanced" :style="{width: '30vw'}" :modal="true" class="globalDialog">
        <template #header>
            <span class="p-dialog-title">{{ popupTitle }}</span>
        </template>	
        <div class="card fluid">       

            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('financedName') }}</label>
                <div class="col-12 md:col-8">
                    <InputText type="text" v-model="tmpName" />						
                </div>                        
            </div>	
            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('finacedDescription') }}</label>
                <div class="col-12 md:col-8">                    	
                    <Textarea v-model="tmpDescription" rows="5"  />								
                </div>                        
            </div>		

            <div class="field grid">
                <label for="name1" class="col-12 md:col-4 mb-md-0">{{ translated('virfinanciranjacombolabel') }}</label>
                <div class="col-12 md:col-8">
                    <Dropdown v-model="financedSourceRecords" :options="financedSourceRecordsAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('virfinanciranjacombolabel')" />					
                </div>                        
            </div>	
            
            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('financedFrom') }}</label>
                <div class="col-12 md:col-8">
                    <Calendar v-model="tmpFinancedFrom" dateFormat="dd. mm. yy" showIcon :manualInput="false" style="width: 100%;" />								
                </div>                        
            </div>	

            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('financedTo') }}</label>
                <div class="col-12 md:col-8">	
                    <Calendar v-model="tmpFinancedTill" dateFormat="dd. mm. yy" showIcon :manualInput="false" style="width: 100%;" />								
                </div>                        
            </div>	
		
                                                    
        </div>
        <template #footer>
            <Button :label="translated('canclebutton')" icon="pi pi-times" @click="closeModalAddFinanced" class="p-button-text"/>
            <Button :disabled="isReadOnly" :label="translated('savebutton')" icon="pi pi-check" @click="closeAndAddModalAddFinanced" autofocus />
        </template>
    </Dialog>    
</template>

<script>

import {FilterMatchMode,FilterOperator} from 'primevue/api';
import createHttp from "@/services/http";
import { computed } from "vue";
import store from "@/store";
import Calendar from 'primevue/calendar';

// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
    components: { Calendar },
  data() {
    return {
        translated: computed(() => store.getters.getTranslate),
        filters1: null,
        loading1: true,
        displayModalAddFinanced: false,
        popupTitle: '',
        tmpId:'',
        tmpName:'',
        tmpDescription: '',
        tmpFinancedFrom: null,
        tmpFinancedTill: null,      
        fmpFinancedSources: null,  
        financedSourceRecords: null,
        financedSourceRecordsAllOptions: []
    }
  },
  created() {
      this.initFilters1();
  },  
  async mounted() {

    const http = createHttp(true);     

    const resultFinancedSources = await http.get(process.env.VUE_APP_API_FOLDER + "/GetFinancedSourceRecords");
    resultFinancedSources.data.forEach(item => {
        const elFinanced = {label: (item.Name + ' - ' + item.Description), value: item.Id}
        this.financedSourceRecordsAllOptions.push(elFinanced)
    })


    
    await this.loadRecords();
    // const http = createHttp(true); 
    // const result = await http.get(process.env.VUE_APP_API_FOLDER + "/GetFinanceRecords");

    // if(result.status==200){
    //     this.financedRecords = result.data
    // }

    // this.loading1 = false
   //console.log(this.paymenttypes)
  },
  methods: {
    parseDate(input) {
        if (!input) {
            return null;
        }

        // 1) If it’s already a Date, just return it
        if (input instanceof Date) {
            return input;
        }

        // 2) If it’s a numeric timestamp
        if (typeof input === 'number') {
            return new Date(input);
        }

        // 3) If it’s a string, parse "dd. mm. yyyy"
        if (typeof input === 'string') {
            const parts = input.split('.');

            if (parts.length < 3) {
                return null;
            }
            const day   = parseInt(parts[0].trim(), 10);
            const month = parseInt(parts[1].trim(), 10) - 1; // JS months are 0–11
            const year  = parseInt(parts[2].trim(), 10);

            console.log(day, month, year);
            if (Number.isNaN(day) || Number.isNaN(month) || Number.isNaN(year)) {
                return null;
            }

            const d = new Date(year, month, day);
            // verify e.g. “31. 02. 2025” doesn’t slip through
            if (
                d.getFullYear() !== year ||
                d.getMonth()    !== month ||
                d.getDate()     !== day
            ) {
                return null;
            }

            console.log('Datum:', d);
            return d;
        }

        // fallback
        return null;
    },
    formatDate(dateTime) {
        if (!dateTime) return '';

        const d = new Date(dateTime);

        // Use browser’s locale (e.g. “sl-SI” for Slovenian) and show day/month/year
        return d.toLocaleDateString(
            'sl-SI',
            navigator.language,
            {
                year:   'numeric',
                month:  '2-digit',
                day:    '2-digit'
            }
        );    
    },
    formatForServer(date) {
        if (!date) return null;

        // ensure it’s a Date
        const d = date instanceof Date ? date : new Date(date);
        const yyyy = d.getFullYear();
        const mm   = String(d.getMonth() + 1).padStart(2, '0');
        const dd   = String(d.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    },    
    async loadRecords() {
        this.loading1 = true

        const http = createHttp(true); 

        const result = await http.get(process.env.VUE_APP_API_FOLDER + "/GetFinanceRecords");

        console.log('prejel nazaj:', result.data);
        if(result.status==200){
            this.financedRecords = result.data
        }

        this.loading1 = false
    },
    getEmptyGuid() {  
        return '00000000-0000-0000-0000-000000000000'
	},
      clearFilter1() {
          this.initFilters1();
      },
      initFilters1() {
          this.filters1 = {
              'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
          }
      },
      openModalAddFinanced() {
          this.popupTitle = this.translated('addingnewfinanced'); 
          this.tmpId = this.getEmptyGuid();
          this.tmpName = '';
          this.tmpDescription = '';
          this.tmpFinancedFrom = null;
          this.tmpFinancedTill = null;
          this.displayModalAddFinanced = true;
          this.financedSourceRecords = null;
      },
      openModalEditFinanced(FinancedObj) {
          
        this.financedSourceRecords = null;
          this.popupTitle = this.translated('editingfinanced'); 
          this.tmpId = FinancedObj.Id
          this.tmpName = FinancedObj.Name
          this.tmpDescription = FinancedObj.Description
          this.tmpFinancedFrom = this.formatDate(FinancedObj.FinancedFrom)
          this.tmpFinancedTill = this.formatDate(FinancedObj.FinancedTill)
          this.displayModalAddFinanced = true

          console.log('FinancedObj', FinancedObj, this.financedSourceRecordsAllOptions);
          // I need to search this.financedSourceRecordsAllOptions for record that value equls FinancedObj.FinancedSourceId
          this.financedSourceRecordsAllOptions.forEach(element => {
              if (element.value == FinancedObj.FinancedSourceId) {
                  this.financedSourceRecords = element.value;                   
              }
          })
          
      },
      closeModalAddFinanced() {
            this.displayModalAddFinanced = false;                    
      },
      async closeAndAddModalAddFinanced() {
            const http = createHttp(true); 
            try {
                console.log('zacnem klic ADD', this.financedSourceRecords);
                /*
                console.log('zacnem klic ADD');
                console.log(http);
                */
                const financedObj = {
                    Id: this.tmpId,
                    Name: this.tmpName,
                    FinancedSourceId: this.financedSourceRecords,
                    Description: this.tmpDescription,
                    FinancedFrom: this.formatForServer(this.parseDate(this.tmpFinancedFrom)),
                    FinancedTill: this.formatForServer(this.parseDate(this.tmpFinancedTill))
                }

                console.log(this.tmpFinancedFrom, this.tmpFinancedTill);
                console.log('parameter:');
                console.log(financedObj);
                
                const response = await http.post(process.env.VUE_APP_API_FOLDER + "/InsertUpdateFinanced", financedObj );
                //console.log('response na ADD/UPDATE')
                //console.log(response)

                if(response.status==200) {
                    // paymentObj.Id = response.data.Id
                    // this.paymenttypes.push(paymentObj)
                    /*
                    console.log('VSE JE OK!!!')
                    console.log('payment types:');
                    console.log(this.paymenttypes);
                    */
                    this.$toast.add({severity:'success', summary:'Confirmed', detail:'Record saved!', life: 3000});

                    await this.loadRecords();
                } else {
                    console.log('ERROR!!!')
                    this.$toast.add({severity:'success', summary:'Confirmed', detail:'ERROR', life: 3000});
                }

                //console.log(response)
                
            } catch (error) {
                //console.log('ERROR TRY CATCHE!');
                console.log(error);
                this.$toast.add({severity:'success', summary:'Confirmed', detail:'ERROR', life: 3000});
            }

            this.displayModalAddFinanced = false
            
      },      
      async deleteFinanced(FinancedObj) {
        this.$confirm.require({
            message: this.translated('financiranjedeletequestion'), //'Are you sure you want DELETE Financed record?',
            header: this.translated('deletetitle'), // 'DELETE?',
            icon: 'pi pi-exclamation-triangle',
            acceptClass: 'p-button-danger',
            accept: async () => {
                //callback to execute when user confirms the action

                const http = createHttp(true); 
                try {
                    //console.log('zacnem klic delete');
                    //console.log(http);
                    const response = await http.delete(process.env.VUE_APP_API_FOLDER + "/DeleteFinancedRecord?id=" + FinancedObj.Id );
                    //console.log('response na DELETE')
                    //console.log(response)

                    if(response.status==200) {
                        /*
                        console.log('VSE JE OK!!!')
                        console.log('payment types:');
                        console.log(FinancedObj.Id);
                        console.log(this.paymenttypes);
                        */
                        // izbrišem še iz kolekcije, da se odstrani iz app
                        // const arr = this.paymenttypes.filter(function(item) {                            
                        //     return item.Id !== FinancedObj.Id
                        // })

                        // this.paymenttypes = arr       
                        await this.loadRecords();                     
                    } else {
                        console.log('ERROR!!!')
                    }

                    //console.log(response)
                } catch (error) {
                    //console.log('ERROR TRY CATCHE!');
                    console.log(error);
                }
                //console.log(FinancedObj);
                this.$toast.add({severity:'success', summary:'Confirmed', detail:'Record deleted', life: 3000});
                //console.log('klical accept');
            },
            reject: () => {
                //console.log('klical reject');
                //callback to execute when user rejects the action
            }
        });
      }
  },
  computed: {
    isReadOnly() {
        return this.$store.getters.isInRole("ReadOnly");
    }
  }
}
</script>

<style scoped>
 button.deletebutton, button.editbutton {
    position: relative;
    float: right;
}
</style>